import styled from 'styled-components';
import { Box } from '@interstate/components/Box';
import { Button } from '@interstate/components/Button';

export const DealTypeDropdownContainer = styled(Box)`
    display: flex;
    gap: 8px;
    flex-direction: column;

    button {
        height: auto;
        min-width: unset;
        justify-content: center;
        padding: 0.5rem 1rem;
    }
`;

export const DealTypeLabel = styled.span`
    font-weight: 600;
    font-size: 14px;
`;

export const CompactDealTypeLabelAndRollToButton = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-top: 0;
    min-height: 25px;
`;

export const CompactDealTypeSelectTrigger = styled(Button)`
    &.MuiButton-root {
        width: 100%;
        border: 1px solid #b2b2b2;
        padding-top: 6px;
        padding-bottom: 6px;
        justify-content: space-between;
    }
`;

export const DealLabelContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
    font-weight: 400;
    span:last-of-type {
        font-size: 12px;
        color: #5a5a5a;
    }
    span:first-of-type {
        color: black;
        font-size: 16px;
    }
`;

export const CompactDealLabelContainer = styled(DealLabelContainer)`
    flex-direction: row;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 4px 8px;
`;
